<template>
  <popup :opened="dataToShow !== ''" @close="changeToShow('')">
    <!-- BEGIN message to confirm the guest revocation -->
    <div
      v-if="dataToShow == 'confirmation'"
      class="mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto"
    >
      <h3 class="mb-10 text-pink-600">Confirmation de révocation des droits</h3>

      <h6 class="text-indigo-600 mb-10">
        Êtes vous sûr de vouloir révoquer les droits de l'invité
        {{ guestToEdit.firstname }}
        <span class="uppercase">{{ guestToEdit.lastname }}</span> sur votre
        Neopass ? <br />
        Cette désactivation sera définitive et irrévocable.
      </h6>

      <div class="w-full flex justify-center">
        <div class="mr-5">
          <action-button
            class="relative flex flex-row"
            border-color="border-pink-600"
            text-color="text-pink-600"
            bg-color="bg-pink-300"
            libelle="ANNULER"
            @clickAction="changeToShow('')"
          />
        </div>
        <div class="w-auto">
          <action-button
            :spinner="inProgress"
            class="relative flex flex-row"
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            libelle="Révoquer"
            type-shadow="shadow-pink"
            :uppercase="true"
            :right="true"
            icon-color="text-white"
            icon="arrow-right_1"
            @clickAction="confirmDeactivateGuest()"
          />
        </div>
      </div>
    </div>
    <!-- END message to confirm the guest revocation -->

    <!-- BEGIN message to confirm revocation -->
    <div
      v-if="dataToShow == 'deactivateSuccess'"
      class="mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto"
    >
      <h3 class="text-indigo-600 mb-10">
        L'invité {{ guestToEdit.firstname }}
        <span class="uppercase">{{ guestToEdit.lastname }}</span> ne peut plus
        gérer votre Neopass.
      </h3>
      <div class="w-full flex justify-center">
        <illustration name="basket" class="w-full" />
      </div>
    </div>
    <!-- END message to confirm revocation -->

    <!-- BEGIN message to indicate user not have rights to revoke this guest -->
    <div
      v-if="dataToShow == 'forbidden'"
      class="mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto"
    >
      <h3 class="text-indigo-600 mb-10">
        Vous n'êtes pas autorisé à révoquer les droits de cet invité
      </h3>
      <div class="w-full flex justify-center">
        <illustration name="notAllowed" class="w-full" />
      </div>
    </div>
    <!-- END message to indicate user not have rights to revoke this guest -->
  </popup>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Popup from './../../../components/Popup';
import Illustration from './../../../components/Illustration';
import ActionButton from './../../../components/ActionButton';

export default {
  name: 'DeleteGuestPopup',

  props: {
    dataToShow: String,
  },

  data() {
    return {
      inProgress: false,
    };
  },

  components: {
    Popup,
    ActionButton,
    Illustration,
  },

  computed: {
    ...mapGetters({
      saving: 'permissions/saving',
      user: 'auth/user',
      guestToEdit: 'invites/guestToEdit',
    }),
  },

  methods: {
    ...mapActions({
      deactivateGuest: 'invites/deactivateGuest',
    }),

    ...mapMutations({
      SET_SAVING: 'permissions/SET_SAVING',
    }),

    changeToShow(val) {
      this.$emit('showChange', val);
    },

    confirmDeactivateGuest() {
      if (this.inProgress) {
        return;
      }
      console.log('deactivate GUEST');
      this.inProgress = true;
      this.deactivateGuest()
        .then((r) => {
          if (r === 403) {
            this.changeToShow('forbidden');
            return;
          }
          this.inProgress = false;
          this.changeToShow('deactivateSuccess');
        })
        .catch((error) => {
          this.inProgress = false;
          console.log('ERRRR:: ', error.response);
        });
    },
  },
};
</script>
